/** @jsxImportSource @emotion/react */
import "./shared/styles/App.css";
import "./shared/styles/themeCustomization.css";
import { useState, useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Router from "./Router";

import {
  Header,
  Estetica,
  FooterMorfeo,
  ProveedorPermisos,
  accessAPI,
  readFromLS
} from "./shared";

// PrimeReact
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import { ProveedorContextoAsistente } from "./secciones/asistente/ContextoAsistente";
import AsistenteLateral from "./secciones/asistente/AsistenteLateral";

/**
 * Encabezado con el menú principal. Va dentro del router porque el ítem
 * Importaciones depende de si el organismo tiene la integración con
 * Penta-Transaction, y eso se consulta recién cuando hay sesión: después del
 * login la app navega sin recargar, así que se vuelve a mirar el token en cada
 * cambio de ruta.
 */
function Encabezado() {
  useLocation();
  const token = readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN);
  const [conPenta, setConPenta] = useState(false);

  useEffect(() => {
    if (!token) {
      setConPenta(false);
      return;
    }
    accessAPI(
      "GET",
      "admin/importacion/integracion",
      null,
      (respuesta) => setConPenta(Boolean(respuesta.conPenta)),
      () => setConPenta(false)
    );
  }, [token]);

  return (
    <Header
      menuUsuarioProps={{
        opcionesRol: ["auditor", "cliente"]
      }}
      botonesMenuUsuario={[
        { etiqueta: "Configuración", uri: "/config", icono: "pi pi-cog" }
      ]}
      buscadorConfig={{
        urlBusquedaRapida: `admin/buscador/buscarDatos?limit=2`,
        urlBusqueda: "/busqueda",
        placeholder: "Buscar...",
        delay: 400,
        minLength: 2
      }}
      botonera={[
        { etiqueta: "Clientes", url: "/clientes" },
        {
          etiqueta: "Facturación",
          url: "/facturacion",
          permiso: "admin.facturacion"
        },
        { etiqueta: "Lista de precios", url: "/lista-precios" },
        { etiqueta: "Muestras", url: "/muestra" },
        {
          etiqueta: "Recursos",
          subitems: [
            {
              etiqueta: "Colaboradores",
              url: "/proveedores/auditores"
            },
            {
              etiqueta: "Laboratorios",
              url: "/proveedores/laboratorios"
            },
            { etiqueta: "Instrumental", url: "/instrumental" },
            { etiqueta: "Acreditación", url: "/acreditacion" },
            { etiqueta: "Comunicación masiva", url: "/comunicaciones" },
            { etiqueta: "Correos sin asignar", url: "/correos-sin-asignar" }
          ]
        },
        {
          etiqueta: "Gestión",
          subitems: [
            { etiqueta: "Documentos", url: "/documento" },
            { etiqueta: "Cumplimiento", url: "/cumplimiento" },
            { etiqueta: "Auditorías SG", url: "/auditoriasg" },
            {
              etiqueta: "Sin planificación",
              url: "/certificados-sin-planificacion"
            },
            ...(conPenta
              ? [{ etiqueta: "Importaciones", url: "/importaciones" }]
              : [])
          ]
        },
        {
          etiqueta: "Indicadores",
          subitems: [
            {
              etiqueta: "Facturación",
              url: "/indicadores/facturacion",
              permiso: "admin.facturacion"
            }
          ]
        }
      ]}
    />
  );
}

export default function App() {
  return (
    <PrimeReactProvider>
      <Estetica app="ADMIN">
      <BrowserRouter>
        <ProveedorPermisos>
        <ProveedorContextoAsistente>
        {/* El asistente envuelve a la app: con el panel abierto, la app se
            achica a su izquierda en vez de quedar tapada. */}
        <AsistenteLateral>
        <div
          // Columna del alto de la ventana: como el footer tiene margin-top
          // auto, queda abajo de todo aunque el contenido no llene la pantalla.
          css={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh"
          }}
        >
          <div
            // El contenido va en su propio div y no suelto en la columna
            // flex: App.css le da `margin: auto` horizontal a <main>, y en un
            // flex container los márgenes auto anulan el stretch y lo
            // encogerían al ancho del texto.
            css={{ flex: "1 0 auto" }}
          >
            <Encabezado />
            <Router />
          </div>
          <FooterMorfeo />
        </div>
        </AsistenteLateral>
        </ProveedorContextoAsistente>
        </ProveedorPermisos>
      </BrowserRouter>
    </Estetica>
    </PrimeReactProvider>
  );
}
